// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3RlPF","hover-typeB-r":"button_hover-typeB-r__23sGg"};